import * as React from 'react';
import apiRequest from 'lib/apiRequest';
import PusherClient from 'pusher/PusherClient';
import MetricTracking from 'lib/MetricTracking';

type Props = { pollingSecret: string; pusherChannel: string; onSuccess: (resp: any) => void };

export default class MagicLinkPoller extends React.Component<Props> {
  componentDidMount() {
    const { pusherChannel, pollingSecret } = this.props;

    MetricTracking.increment('magic_links.poller.started');
    PusherClient.subscribe(pusherChannel)
      .then((channel) => {
        channel.bind_all((type: string, eventData: any) => {
          if (type === 'v3.changeset') {
            if (eventData.changes[0].token === pollingSecret) {
              apiRequest('/devices/outbound_verification/link/poll', 'POST', {
                polling_secret: pollingSecret,
              }).then((resp) => {
                MetricTracking.increment('magic_links.poller.success');
                this.props.onSuccess(resp);
              });
            }
          }
        });
      })
      .catch((err) => {
        MetricTracking.increment('magic_links.poller.error');
        console.error('MagicLinkPoller', err);
      });
  }

  componentWillUnmount() {
    PusherClient.unsubscribe(this.props.pusherChannel);
  }

  render() {
    return <div />;
  }
}
